import React, { memo } from 'react';
import { Box } from '@mui/material';
import SportsSoccerIcon from '@mui/icons-material/SportsSoccer';

interface TeamLogoProps {
  teamId?: string; // Keep for backward compatibility
  teamName: string;
  size?: number;
  logoPath?: string;
  logoUrl?: string;
}

export const TeamLogo: React.FC<TeamLogoProps> = memo(({
  teamName,
  size = 32,
  logoPath,
  logoUrl
}) => {
  const [error, setError] = React.useState(false);

  // Reset error state when logo props change
  React.useEffect(() => {
    setError(false);
  }, [logoPath, logoUrl]);

  // Determine logo source - prefer logoPath (downloaded) over logoUrl
  const logoSrc = logoPath ? `/${logoPath}` : logoUrl;

  if (!logoSrc || error) {
    return (
      <Box
        sx={{
          width: size,
          height: size,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }}
      >
        <SportsSoccerIcon sx={{ fontSize: size * 0.8, color: 'text.secondary' }} />
      </Box>
    );
  }

  return (
    <Box
      component="img"
      src={logoSrc}
      alt={teamName}
      sx={{
        width: size,
        height: size,
        objectFit: 'contain'
      }}
      onError={() => setError(true)}
    />
  );
});
